import Axios from 'axios';
import A11yDialog from 'a11y-dialog';

class DialogButton {
  constructor (element) {
    const allyId = element.querySelector('[data-a11y-dialog-show]').dataset
      .a11yDialogShow;
    this.dialog = document.getElementById(allyId);
    this.submitButton = this.dialog.querySelector('.button-form');
    this.submitUrl = this.dialog.dataset.formSubmitUrl;

    this.addEvents();
  }

  addDialogs () {
    if (this.dialog) {
      const dialogInit = new A11yDialog(this.dialog); // eslint-disable-line no-unused-vars
    }
  }

  addEvents () {
    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const emailInputValue = this.dialog.querySelector('[type="email"]').value;
      const privacyInputChecked = this.dialog.querySelector('[name="ds"]').checked;

      Axios.post(this.submitUrl, {
        privacyChecked: privacyInputChecked,
        email: emailInputValue
      })
        .then(function (response) {
          window.location = response.data.url;
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  }

  init () {
    this.addDialogs();
    this.addEvents();
  }
}
export default DialogButton;
